/**
 * An SampleTarget used for the mail campaigns
 * @param {string} name - Name
 * @param {string} weez_orga_id - Weezevent ID
 * @returns {Class} - Role instance
 */
export default class SampleTarget {
	constructor({
		id,
		name,
		targets,
		archived
	} = {}) {
		this._id = id || null;
		this._name = name || null;
		this._targets = targets || [];
		this._archived = archived || null;
	}

	getId() {
		return this._id;
	}

	getKey() {
		return String(this._id);
	}
    
	getName() {
		return this._name;
	}

	getTargets() {
		return this._targets;
	}

	getArchived() {
		return this._archived;
	}

}
